/*
 * Load Vue
 */
if (window.Vue === undefined) {
    window.Vue = require("vue");

    window.Bus = new Vue();
}

import { Vue2Storage } from "vue2-storage";
import PortalVue from "portal-vue";

// You can pass options
Vue.use(Vue2Storage);
Vue.use(PortalVue);

/**
 * Load Vue Global Mixin.
 */
Vue.mixin(require("./mixin"));

/**
 * Define the Vue filters.
 */
require("./filters");

/**
 * Load the form utilities.
 */
require("./forms/bootstrap");

/**
 * Load directives
 */
require("./directives");

